import { apiToken, apiBasic, apiTokenNotDecode, apiGet, logout } from "./requests";

export const logIn = (data = null) => {
  let path = "login";
  return apiTokenNotDecode(data, path);
};

export const logOut = () => {
  return logout();
};

export const validateLogIn = (data) => {
  let path = "validate";
  return apiBasic(data, path);
};

export const recoverPassword = (data = null) => {
  let path = "forgot-password";
  return apiBasic(data, path);
};

export const resetPassword = (data) => {
  let path = "reset-password";
  return apiToken(data, path);
};

export const checkPassword = (data) => {
  let path = "check-delivery-password";
  return apiTokenNotDecode(data, path);
};

export const getUsersAccess = () => {
  let path = "get-users-with-access";
  return apiGet(path);
};

export const setOrderManager = (data = null) => {
  let path = "select-order-manager-configuration";
  return apiBasic(data, path);
};
